module.exports = __webpack_public_path__ + "img/product-placeholder-90.286e554.png";